import React from "react";
import Modal from "../UI/Modal";
import { connect } from "react-redux";
import sucess from "../../assets/images/new-images/sucess.png";
import dltIcon from "../../assets/images/new-images/dlt.png";
import { useState } from "react";
import { deleteNotificationType } from "../../actions/action-master";

const DeleteNotificationType = ({
  deleteId,
  setNotificationTypes,
  notificationTypes,
  deleteNotificationType,
  ...props
}) => {
  const [typeDelete, setTypeDelete] = useState(true);

  const typesDeleteHandler = () => {
    setTypeDelete(!typeDelete);
  };

  const deleteType = (id) => {
    deleteNotificationType(id);
    setTypeDelete(!typeDelete);
  };

  return (
    <Modal
      modalId={"deleteTypesModal"}
      modalLabel={"deleteTypesModalLabel"}
      className={"dlt-modal"}
    >
      <div className="modal-dialog modal-dialog-centered ">
        <div className="modal-content">
          <div className="modal-body text-center pt-0">
            <img
              src={typeDelete ? dltIcon : sucess}
              alt="icon"
              className="m-3"
            />

            {typeDelete && <p className="dlt-hed">Are you sure ?</p>}

            <p className="dlt-body">
              {typeDelete
                ? "Do you want to delete this record? Once deleted, this action cannot be undone"
                : "Notification Type Deleted Successfully"}
            </p>
          </div>
          <div className="modal-footer">
            {typeDelete && (
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            )}

            {typeDelete ? (
              <button
                type="button"
                className="btn btn-genmeb ms-3"
                onClick={() => deleteType(deleteId)}
              >
                Delete
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-genmeb ms-3"
                data-bs-dismiss="modal"
                onClick={typesDeleteHandler}
              >
                Ok
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = ({ master }) => ({});

const mapDispatchToProps = (dispatch) => ({
  deleteNotificationType: (payload) =>
    dispatch(deleteNotificationType(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteNotificationType);
